/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./certificados.component.css.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "../../services/user.service";
import * as i3 from "@angular/http";
import * as i4 from "../../services/certificados.service";
import * as i5 from "./certificados.component";
import * as i6 from "@angular/router";
var styles_CertificadosComponent = [i0.styles];
var RenderType_CertificadosComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_CertificadosComponent, data: {} });
export { RenderType_CertificadosComponent as RenderType_CertificadosComponent };
export function View_CertificadosComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "H1", [], null, null, null, null, null)), (_l()(), i1.ɵted(-1, null, ["CERTIFICADOS"]))], null, null); }
export function View_CertificadosComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 3, "page-certificados", [], null, null, null, View_CertificadosComponent_0, RenderType_CertificadosComponent)), i1.ɵprd(512, null, i2.UserService, i2.UserService, [i3.Http]), i1.ɵprd(512, null, i4.CertificadosService, i4.CertificadosService, [i3.Http]), i1.ɵdid(3, 114688, null, 0, i5.CertificadosComponent, [i6.Router, i2.UserService, i4.CertificadosService], null, null)], function (_ck, _v) { _ck(_v, 3, 0); }, null); }
var CertificadosComponentNgFactory = i1.ɵccf("page-certificados", i5.CertificadosComponent, View_CertificadosComponent_Host_0, {}, {}, []);
export { CertificadosComponentNgFactory as CertificadosComponentNgFactory };
